import ReactInlineSvg from 'react-inlinesvg';
export const WhatsappAuth = ({ clickHandler }) => {
  return (
    <div className="whatsapp-auth" onClick={clickHandler}>
      <ReactInlineSvg src="/images/icons/social/auth_whatsapp.svg" desciption="whatsapp" />
    </div>
  );
};
